import axios from "axios";

// export const baseURL = "https://preser.dev";
// export const baseURL = "https://api.preser.app";
export const baseURL = "https://apiv2.preser.app";
// export const baseURL = 'http://localhost:3333';
// export const baseURL = "https://prma.herokuapp.com";
//  export const baseURL = "https://veon-test.herokuapp.com";

const baseEndpoint = "/api";

type Headers = { [key: string]: string }

export const client = (headers?: Headers) => {
  const token = localStorage.getItem("token");
  if (token) {
    return axios.create({
      baseURL: baseURL + baseEndpoint,

      headers: { Authorization: `Bearer ${token}`, ...headers },
    });
  }
  return axios.create({
    baseURL: baseURL + baseEndpoint,
  });
};
